import React from "react";
import "./Dpu_Mca_Alumini.css";

const Dpu_Mca_Alumini = () => {
  const alumniLogos = [
    { img: "/assets/images/dpu_mca/alumini/amazone.webp", alt: "Amazon Logo" },
    {
      img: "/assets/images/dpu_mca/alumini/americanexpress.webp",
      alt: "American Express",
    },
    { img: "/assets/images/dpu_mca/alumini/amul.webp", alt: "Amul Logo" },
    {
      img: "/assets/images/dpu_mca/alumini/AxisBanklogo.webp",
      alt: "Axis Bank",
    },
    { img: "/assets/images/dpu_mca/alumini/bajaj.webp", alt: "Bajaj Finserv" },
    {
      img: "/assets/images/dpu_mca/alumini/bandhanbank.webp",
      alt: "Bandhan Bank",
    },

    { img: "/assets/images/dpu_mca/alumini/calance.webp", alt: "Calance" },
    { img: "/assets/images/dpu_mca/alumini/capgemini.webp", alt: "Capgemini" },
    { img: "/assets/images/dpu_mca/alumini/Cognizant.webp", alt: "Cognizant" },
    { img: "/assets/images/dpu_mca/alumini/deloitte.webp", alt: "Deloitte" },
    { img: "/assets/images/dpu_mca/alumini/EClerx.webp", alt: "EClerx" },
    { img: "/assets/images/dpu_mca/alumini/exatech.webp", alt: "ExaTech" },

    { img: "/assets/images/dpu_mca/alumini/EY.webp", alt: "EY Logo" },
    { img: "/assets/images/dpu_mca/alumini/genpact.webp", alt: "Genpact" },
    { img: "/assets/images/dpu_mca/alumini/google.webp", alt: "Google" },
    { img: "/assets/images/dpu_mca/alumini/grapeCity.webp", alt: "GrapeCity" },
    { img: "/assets/images/dpu_mca/alumini/HCLtech.webp", alt: "HCL Tech" },
    { img: "/assets/images/dpu_mca/alumini/hdfcbank.webp", alt: "HDFC Bank" },

    { img: "/assets/images/dpu_mca/alumini/itc.webp", alt: "ITC Limited" },
    { img: "/assets/images/dpu_mca/alumini/pwc.webp", alt: "PwC Logo" },
    {
      img: "/assets/images/dpu_mca/alumini/mygenomebox.webp",
      alt: "My Genomebox",
    },
    { img: "/assets/images/dpu_mca/alumini/nobroker.webp", alt: "No Broker" },
    { img: "/assets/images/dpu_mca/alumini/tcs.webp", alt: "TCS" },
    {
      img: "/assets/images/dpu_mca/alumini/techmahindra.webp",
      alt: "Tech Mahindra",
    },
  ];

  return (
    <section className="Dpu_Mca_Alumini">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="fs-3 text-black text-center section_title">
              Where Our Alumni Stand Today
            </h2>
          </div>
        </div>

        {Array.from({ length: Math.ceil(alumniLogos.length / 6) }).map(
          (_, rowIndex) => (
            <div className="row" key={rowIndex}>
              {alumniLogos
                .slice(rowIndex * 6, rowIndex * 6 + 6)
                .map((logo, index) => (
                  <div className="col-lg-2  col-4" key={index}>
                    <img src={logo.img} className="img-fluid" alt={logo.alt} />
                  </div>
                ))}
            </div>
          ),
        )}
      </div>
    </section>
  );
};

export default Dpu_Mca_Alumini;
